<template>
  <div class="v-checkbox">
    <label class="v-checkbox__container">
      <input
        class="v-checkbox__input"
        type="checkbox"
        :checked="isChecked"
        @change="onChangedEventHandler()"
      >
      <div class="v-checkbox__text-container">
        <span class="v-checkbox__text">
          <slot/>
        </span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "VCheckbox",
  props: {
    isChecked: Boolean
  },
  model: {
    prop: "isChecked",
    event: "onChecked"
  },
  methods: {
    onChangedEventHandler() {
      this.$emit("onChecked", !this.isChecked);
    }
  }
};
</script>

<style>
.v-checkbox {
  user-select: none;
  font-family: PlumbLightC, sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #384656;
}

.v-checkbox__container {
  cursor: pointer;
}

.v-checkbox__input {
  display: none;
}

.v-checkbox__text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.v-checkbox__text {
  margin-left: 10px;
}

.v-checkbox__text-container::before {
  content: "";
  height: 0.6em;
  width: 0.6em;
  background-color: rgb(210, 210, 217);
  border: 2px solid rgb(210, 210, 217);
  border-radius: 3px;
  display: inline-block;
}

.v-checkbox__input:checked + .v-checkbox__text-container::before {
  background-color: rgb(2, 142, 213);
}

@media only screen and (max-width: 600px) {
  .v-checkbox {
    font-size: 14px;
  }
}
</style>

